import { StatCard } from '@/common/dashboard/StatCard';
import { Spacer } from '@/common/layout/SpacerLayout';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';
import { useDispReqParam } from './useDispReqParam';

export const McdDispOutcomeSummaryCards = ({ dispCodeCount }) => {
  const rsrc = useRsrc();
  const [totals, setTotals] = useState();
  const reqParam = useDispReqParam(dispCodeCount);

  useEffect(() => {
    let stale = false;
    rsrc.data('sc', 'MCD_DISP_OUTCOME_SUMMARY_DATA_PLUGIN', reqParam).then((res) => {
      if (!stale) setTotals(res);
    });
    return () => {
      stale = true;
    };
  }, [reqParam]);

  if (!totals) return null;

  // URA Revisions re-price disputes rather than resolve them, so they qualify Created instead of standing alone
  return (
    <Spacer weights={[1, 1, 1, 1, 1]}>
      <StatCard
        title="Created"
        val={totals.createdAmt}
        isAmt
        footnote={{ label: 'URA Revisions', val: totals.uraRevisionAmt }}
      />
      <StatCard title="Accepted" val={totals.acceptedAmt} isAmt />
      <StatCard title="Rejected (Paid)" val={totals.rejectedPaidAmt} isAmt />
      <StatCard title="Rejected (Due)" val={totals.rejectedDueAmt} isAmt />
      <StatCard title="Outstanding Disputes" val={totals.outstandingAmt} isAmt />
    </Spacer>
  );
};
